/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { CompetenceLangViewModel } from "../types/CompetenceLangViewModel.ts";

export const competenceLangViewModelSchema = z.object({
  id: z.optional(z.number().int().describe("ID da tradução da competência.")),
  competenceId: z.optional(
    z.number().int().describe("ID da competência à qual a tradução pertence."),
  ),
  name: z.string().describe("Nome da competência neste idioma.").nullish(),
  description: z
    .string()
    .describe("Descrição da competência neste idioma. Opcional.")
    .nullish(),
  cultureInfo: z
    .string()
    .describe("Código do idioma (cultura) da tradução.")
    .nullish(),
  cultureDisplayName: z
    .string()
    .describe("Nome amigável do idioma da tradução.")
    .nullish(),
}) as unknown as ToZod<CompetenceLangViewModel>;
